<span
  class="checkout-header d-flex justify-content-center"
  *ngIf="!isOrderPlaced"
  >{{ "checkoutorderlist.checkout" | cxTranslate }}</span
>
<span
  class="checkout-header d-flex justify-content-center"
  *ngIf="isOrderPlaced && !isOrderDetails"
  >{{ "checkoutorderlist.thankyouforOrder" | cxTranslate }}</span
>
<span
  class="checkout-header d-flex justify-content-center"
  *ngIf="isOrderDetails"
  >{{ "checkoutorderlist.orderdetails" | cxTranslate }}</span
>
<div class="order-details">
  <div class="row p-4 m-0">
    <div class="order-details-column d-flex flex-column" *ngIf="!isOrderPlaced">
      <span class="order-detail-top-label">{{
        "checkoutorderlist.ponum" | cxTranslate
      }}</span>
      <span class="order-detail-top-value">{{
        shipToObj.purchaseOrderNumber
      }}</span>
    </div>
    <div class="order-details-column d-flex flex-column" *ngIf="isOrderPlaced">
      <span class="order-detail-top-label">{{
        "checkoutorderlist.ordernum" | cxTranslate
      }}</span>
      <span class="order-detail-top-value">{{ orderData.code }}</span>
    </div>
    <div class="order-details-column d-flex flex-column" *ngIf="isOrderPlaced">
      <span class="order-detail-top-label">{{
        "checkoutorderlist.ponum" | cxTranslate
      }}</span>
      <span class="order-detail-top-value">{{
        shipToObj.purchaseOrderNumber
      }}</span>
    </div>
    <div class="order-details-column d-flex flex-column" *ngIf="isOrderDetails">
      <span class="order-detail-top-label">{{
        "checkoutorderlist.status" | cxTranslate
      }}</span>
      <span class="order-detail-top-value status-value">{{
        orderData?.statusDisplay
      }}</span>
    </div>
    <div class="order-details-column d-flex flex-column">
      <span class="order-detail-top-label">{{
        "checkoutorderlist.shipto" | cxTranslate
      }}</span>
      <span class="order-detail-top-value">{{
        shipToObj?.deliveryAddress?.companyName
      }}</span>
      <span>{{ shipToObj?.deliveryAddress?.line1 }}</span>
      <span>{{ shipToObj?.deliveryAddress?.line2 }}</span>
      <span>{{ shipToObj?.deliveryAddress?.region?.name }}</span>
      <span
        >{{ shipToObj?.deliveryAddress?.town }},
        {{ shipToObj?.deliveryAddress?.postalCode }}</span
      >
      <span>{{ shipToObj?.deliveryAddress?.country?.name }}</span>
    </div>
    <div class="order-details-column d-flex flex-column" *ngIf="isOrderPlaced">
      <span class="order-detail-top-label" *ngIf="!isOrderDetails">{{
        "checkoutorderlist.placedon" | cxTranslate
      }}</span>
      <span class="order-detail-top-label" *ngIf="isOrderDetails">{{
        "checkoutorderlist.lastplacedon" | cxTranslate
      }}</span>
      <span class="order-detail-top-value" *ngIf="!isOrderDetails">{{
        orderData?.created | date : "dd-MM-yyyy"
      }}</span>
      <span class="order-detail-top-value" *ngIf="isOrderDetails">{{
        orderData?.created | date : "dd MMMM yyyy"
      }}</span>
    </div>
    <div
      class="order-details-column d-flex flex-column"
      *ngIf="!isOrderDetails"
    >
      <span class="order-detail-top-label">{{
        "checkoutorderlist.requestedDate" | cxTranslate
      }}</span>
      <span class="order-detail-top-value" *ngIf="!isOrderPlaced">{{
        shipToObj.requestedDeliveryDate
      }}</span>
      <span class="order-detail-top-value" *ngIf="isOrderPlaced">{{
        orderData?.expectedDeliveryDate | date : "dd-MM-yyyy"
      }}</span>
    </div>
  </div>
</div>
